import { Injectable } from '@angular/core';

/**
 * Service for building solicitud de disponibilidad objects
 * Handles encoding, sanitization, and object construction
 */
@Injectable()
export class SolicitudDisponibilidadBuilderService {

    constructor() { }

    /**
     * Sanitizes text by removing newlines, tabs, and carriage returns
     * @param text Text to sanitize
     * @returns Sanitized text with single spaces
     */
    sanitizeText(text: string): string {
        if (!text) return '';
        return text.replace(/[\n\r\t]+/g, " ");
    }

    /**
     * Sanitizes location strings (alias and direccion) for origen and destino
     * Removes newlines/tabs. URL encoding of the request body happens once,
     * at the transport layer in CotizacionesService, so it isn't duplicated here.
     *
     * @param origen Origin location object with alias and direccion
     * @param destino Destination location object with alias and direccion
     * @returns Object with sanitized origen and destino
     */
    encodeLocationStrings(origen: any, destino: any): { origen: any; destino: any } {
        const encodedOrigen = {
            ...origen,
            alias: this.sanitizeText(origen.alias),
            direccion: this.sanitizeText(origen.direccion)
        };

        const encodedDestino = {
            ...destino,
            alias: this.sanitizeText(destino.alias),
            direccion: this.sanitizeText(destino.direccion)
        };

        return { origen: encodedOrigen, destino: encodedDestino };
    }

    /**
     * Builds complete solicitud de disponibilidad object
     *
     * @param params Object with all required solicitud parameters
     * @returns Formatted solicitud object ready for API submission
     */
    buildSolicitudObject(params: {
        tipoDeUnidad: any;
        idCotizacion: string;
        idTrosten: string;
        combinacion: any;
        oficinaDeOrigen: any;
        inicioDeServicio: number;
        finDeServicio: number;
        origen: any;
        destino: any;
        conceptosAdicionales: any;
        tipoDeVenta: string;
        cliente: string;
    }): any {

        const { tipoDeUnidad, idCotizacion, idTrosten, combinacion, oficinaDeOrigen, inicioDeServicio, finDeServicio, origen, destino, conceptosAdicionales, tipoDeVenta, cliente } = params;

        // Encode origen and destino strings
        const encoded = this.encodeLocationStrings(origen, destino);

        return {
            oficinaDeOrigen: oficinaDeOrigen,
            tipoDeUnidad: tipoDeUnidad,
            idCotizacion: idCotizacion,
            idTrosten: idTrosten,
            combinacion: combinacion,
            inicioDeServicio: inicioDeServicio,
            finDeServicio: finDeServicio,
            origen: encoded.origen,
            destino: encoded.destino,
            conceptosAdicionales: conceptosAdicionales,
            tipoDeVenta: tipoDeVenta,
            cliente: cliente
        };
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/business-logic/solicitud-disponibilidad-builder.service.ts